var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.asImg)?_c('img',_vm._g({class:['v-img', _vm.name],style:(_vm.style),attrs:{"src":_vm.content}},_vm.$listeners)):_c('div',_vm._g({class:{ 'v-svg': true, 'use-parent-color': _vm.useParentColor, 'v-svg-active': _vm.active, [_vm.name]: true },style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.content)}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }